var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('main',{attrs:{"id":"page-wrap"}},[_c('transition',{attrs:{"name":"show","mode":"out-in"}},[_c('router-view')],1),_c('Footer'),_c('Subscription'),_c('Lgpd')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }